import { createCustomEnum } from "./customEnum";

export type UnderwritingTabsType =
	| "unassigned"
	| "in-review"
	| "pended"
	| "historical"
	| "concurrence-conditions"
	| "qa-unassigned"
	| "qa-complete"
	| "qa-in-progress";

const UnderwritingTabs = createCustomEnum({
	Unassigned: {
		value: 1,
		name: "unassigned",
		displayName: "Unassigned",
	},
	InReview: {
		value: 2,
		name: "in-review",
		displayName: "In Review",
	},
	Pended: {
		value: 3,
		name: "pended",
		displayName: "Pended",
	},
	Historical: {
		value: 4,
		name: "historical",
		displayName: "Historical",
	},
	Concurrence: {
		value: 5,
		name: "concurrence-conditions",
		displayName: "Concurrence / Conditions",
	},
	QAUnassigned: {
		value: 6,
		name: "qa-unassigned",
		displayName: "QA Unassigned",
	},
	QAComplete: {
		value: 7,
		name: "qa-complete",
		displayName: "QA Complete",
	},
	QAInProgress: {
		value: 8,
		name: "qa-in-progress",
		displayName: "QA In Progress",
	},
});

export default UnderwritingTabs;
